import { MAP_LEGEND_RANGE } from '../../../common/utils/constants'
import { COLOR_MAP } from '../../../common/utils/theme'

const MapLegend = () => {
  const legendRangeDivs = MAP_LEGEND_RANGE.map((item) => (
    <div className="map-legand-label" key={item}>
      {item}
    </div>
  ))

  const colorsDiv = COLOR_MAP.mapLegend1.map((item) => (
    <div className="map-legand-color" key={`color-${item}`}>
      <div className="map-legand" style={{ background: item }}></div>
    </div>
  ))

  return (
    <div className="map-legand-components">
      <div className="map-legand-row">
        <div className="map-legand-label">No data </div>
        {legendRangeDivs}
      </div>
      <div className="map-legand-row">
        <div className="map-legand-color">
          <div
            className="map-legand line1"
            style={{ background: COLOR_MAP.noData }}
          ></div>
        </div>
        {colorsDiv}
      </div>
    </div>
  )
}
export default MapLegend
